// Funnel tracker — one tiny beacon per step. No cookies, no fingerprinting:
// a per-tab session id + the event name. Bots are flagged server-side.
export type FunnelEvent =
  | 'catalog_view'
  | 'product_view'
  | 'demo_click'
  | 'pricing_view'
  | 'checkout_start'
  | 'partner_signup'
  | 'find_business'

function sessionId(): string {
  try {
    let id = sessionStorage.getItem('qordo_sid')
    if (!id) {
      id = Math.random().toString(36).slice(2) + Date.now().toString(36)
      sessionStorage.setItem('qordo_sid', id)
    }
    return id
  } catch {
    return 'nosession'
  }
}

export function track(event: FunnelEvent, data: { product?: string } = {}) {
  try {
    const body = JSON.stringify({
      event,
      path: window.location.pathname,
      product: data.product ?? null,
      sid: sessionId(),
      lang: localStorage.getItem('qordo_lang') ?? null,
    })
    if (typeof navigator.sendBeacon === 'function') {
      navigator.sendBeacon('/api/track/event', new Blob([body], { type: 'application/json' }))
    } else {
      // .catch is mandatory: a rejected beacon (jsdom/tests, offline) must never surface as an unhandled rejection
      fetch('/api/track/event', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true }).catch(() => {})
    }
  } catch {
    /* analytics must never break the page */
  }
}
